module.exports = __webpack_public_path__ + "static/media/training.7efa4cd4.png";